import React from 'react';
import Select from 'react-select';
import { ActionState } from 'services/EpdClient';
import { useTheme } from 'styled-components';
import { Theme } from 'styles/theme';
import { Option } from 'types/types';

import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';
import SmartLabel, { TSmartLabelProps } from '../labels/SmartLabel';
import { ClearIndicator, DropdownIndicator } from './common-icons';
import { getCustomWizardSelectStyles } from './select-styles';

type TProps = Partial<TSmartLabelProps> & {
  name: string;
  value?: any;
  options: any[] | undefined;
  isMulti?: boolean;
  style?: any;
  containerClassName?: string;
  containerStyle?: any;
  onChanged: any;
  placeholder?: string;
  disabled?: boolean;
  isClearable?: boolean;
  error?: any;
  state?: Record<string, ActionState>;
  isOptionDisabled?: (option: any, selectValue: any[]) => boolean;
  filterOption?: any;
};

const CompilerSelectControlledComponent: React.FunctionComponent<TProps> = ({
  label,
  options,
  tooltip,
  tooltipPosition,
  labelStyle,
  containerClassName,
  containerStyle,
  name,
  value,
  onChanged,
  disabled,
  isOptionDisabled,
  style,
  placeholder,
  required,
  isMulti,
  isClearable = true,
  error,
  state,
  ...props
}) => {
  const theme = useTheme() as Theme;
  const customSelectStyles = getCustomWizardSelectStyles(theme);
  const isReadOnly = useIsReadOnlyMode() || disabled;

  return (
    <div
      className={containerClassName}
      style={{
        ...containerStyle,
        width: '100%',
        display: state?.[name] === ActionState.Hidden ? 'none' : 'flex',
        flexDirection: 'column',
      }}
    >
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          tooltipPosition={tooltipPosition}
          hasValue={
            isMulti ? value && value.length > 0 : value?.value !== undefined && value?.value !== null && value?.value !== ''
          }
          error={error}
        />
      )}
      <Select
        components={{ ClearIndicator, DropdownIndicator }}
        options={options}
        name={name}
        value={value}
        onChange={(e: any) => {
          const newValue = isMulti ? e?.map((x: Option) => x.value) : e?.value;
          if (onChanged.length === 2) {
            onChanged(name, newValue);
          } else {
            onChanged(name, newValue, value?.value);
          }
        }}
        isClearable={isClearable}
        isMulti={isMulti}
        isDisabled={isReadOnly}
        isOptionDisabled={isOptionDisabled as any}
        styles={customSelectStyles}
        {...props}
      />
    </div>
  );
};

export default CompilerSelectControlledComponent;
